import { useTrkptsWS } from '../utils/hooks'
import { sortBy, keys, pickBy, clone } from 'lodash'
import SelectSlider from './SelectSlider'
import { SelectSliderContainer } from '../components/StyledElements'
import { useEffect } from 'react'

const SlidersGroup = ({
  sliders,
  domain,
  handleDelSlider,
  handleSliderChange,
  handleSliderUpdate,
  chart,
  xslider,
}) => {
  const { trkptsWS } = useTrkptsWS()

  useEffect(() => {
    if (!chart.current) return

    const points = chart.current.chart.series[0].points.map(
      (point) =>
        (point = {
          x: point.x,
          y: point.y,
          color: 'blue',
        })
    )
    chart.current.chart.series[0].setData(points)

    if (sliders.length !== 0) {
      sliders.map((slider) => {
        const to_select = keys(
          pickBy(points, (point) => {
            return point.x >= slider[0] && point.x <= slider[1]
          })
        )
        to_select.map(
          (key) =>
            (points[key] = {
              x: points[key].x,
              y: points[key].y,
              color: 'green',
            })
        )
      })
      chart.current.chart.series[0].setData(points)
    }
  }, [])

  useEffect(() => {
    if (!chart.current) return
    const colors = ['#7cb5ec', '#f7a35c', '#90ed7d', 'blue']
    let zones = []
    let aggregatedSliders = []
    if (sliders.length !== 0) {
      const temp_sliders = sortBy(sliders, (slider) => slider[0])
      aggregatedSliders.push(clone(temp_sliders[0]))
      for (let i = 1; i < temp_sliders.length; i++) {
        const start_new_slider = temp_sliders[i][0]
        const end_new_slider = temp_sliders[i][1]
        let flag = false
        let j = 0
        while (j < aggregatedSliders.length && !flag) {
          const start_a_slider = aggregatedSliders[j][0]
          const end_a_slider = aggregatedSliders[j][1]
          if (
            start_new_slider >= start_a_slider &&
            end_new_slider <= end_a_slider
          ) {
            flag = true
          } else if (
            start_new_slider < start_a_slider &&
            end_new_slider > end_a_slider
          ) {
            aggregatedSliders[j][0] = start_new_slider
            aggregatedSliders[j][1] = end_new_slider
            flag = true
          } else if (
            start_new_slider < start_a_slider &&
            end_new_slider <= end_a_slider &&
            end_new_slider >= start_a_slider
          ) {
            aggregatedSliders[j][0] = start_new_slider
            flag = true
          } else if (
            start_new_slider >= start_a_slider &&
            start_new_slider <= end_a_slider &&
            end_new_slider > end_a_slider
          ) {
            aggregatedSliders[j][1] = end_new_slider
            flag = true
          }
          aggregatedSliders = sortBy(
            aggregatedSliders,
            (aggregatedSlider) => aggregatedSlider[0]
          )
          j++
        }
        if (flag === false) {
          aggregatedSliders.push(clone(temp_sliders[i]))
        }
      }
      const sortAggregatedSliders = sortBy(
        aggregatedSliders,
        (aggregatedSlider) => aggregatedSlider[0]
      )
      for (let i = 0; i < sortAggregatedSliders.length; i++) {
        zones.push({ value: sortAggregatedSliders[i][0], color: colors[0] })
        zones.push({ value: sortAggregatedSliders[i][1], color: colors[1] })
      }
    }

    chart.current.chart.series[0].update({ zones: zones })
  }, [sliders])

  const onDelSlider = (index) => {
    handleDelSlider(index)
  }

  const sliders_a = sliders.map((value, index) => {
    return (
      <SelectSliderContainer
        id="selectSliderContainer"
        chart={chart}
        xslider={xslider}
      >
        <SelectSlider
          handleSliderChange={handleSliderChange}
          handleSliderUpdate={handleSliderUpdate}
          timeDomain={domain}
          handlesValues={value}
          index={index}
          chart={chart}
        />
        <button
          className="button is-info is-small mr-2"
          onClick={() => onDelSlider(index)}
          title="Supprimer la sélection de points"
        >
          -
        </button>
      </SelectSliderContainer>
    )
  })

  return <>{sliders_a.length > 0 && sliders_a}</>
}

export default SlidersGroup
